<a [href]="publicConfig.supportWhatsappUrl()"
  target="_blank"
  rel="noopener noreferrer"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  class="fixed z-50 flex items-center gap-[6px] cursor-pointer
         bottom-[110px] right-4
         md:bottom-[110px] md:right-6
         lg:bottom-8 lg:right-8"
  [class.hidden]="hiddenOnCurrentView()"
  [class.md:flex]="hiddenOnCurrentView()"
>
  <div class="support-label" [class.hidden-label]="!labelVisible()">
    <span class="font-medium text-[12px] text-[#1c2024] tracking-[0.04px] whitespace-nowrap leading-[19px]">
      {{ 'SUPPORT_WIDGET.LABEL' | translate }}
    </span>
  </div>

  <div class="relative shrink-0 size-[62px]">
    <img src="support-avatar.png" [attr.alt]="'SUPPORT_WIDGET.AVATAR_ALT' | translate" class="block w-full h-full" />
    <img src="support-dots.svg" alt="" class="absolute top-0 right-0 w-[24px] h-[21px]" />
  </div>
</a>
